import { useEffect } from 'react'
import { useAccountStyles } from '../fetch'
import { extractPureCss } from 'src/utils'

export const useInjectCss = () => {
  const { data: cssHref } = useAccountStyles()

  useEffect(() => {
    if (!cssHref) return

    const id = 'tg-custom-css'
    const controller = new AbortController()

      ; (async () => {
        try {
          const res = await fetch(cssHref, { signal: controller.signal })
          if (!res.ok) throw new Error(`HTTP ${res.status}`)
          const raw = await res.text()
          const css = extractPureCss(raw)

          // remove previous tag we control (style or link)
          document.getElementById(id)?.remove()

          // inject as a <style> (works for any CSS text)
          const style = document.createElement('style')
          style.id = id
          style.appendChild(document.createTextNode(css))
          document.head.appendChild(style)
        } catch (_err) {
          // optional: fallback to <link> if fetch succeeded but parsing failed
        }
      })()

    return () => {
      controller.abort()
    }
  }, [cssHref])
}
